import { render, staticRenderFns } from "./questionBankDetail.vue?vue&type=template&id=5dcd99e8&scoped=true&"
import script from "./questionBankDetail.vue?vue&type=script&lang=js&"
export * from "./questionBankDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcd99e8",
  null
  
)

export default component.exports